import React, { useEffect, useState } from 'react'
import { Paper } from '@mui/material'
import api from '../../API/api';
import FormDialog from '../modal/modal';
import AddHiring from '../../AdminPages/form/addHiring';



const Hiring = () => {

    const [career, setCareer] = useState();
    const [open, setOpen] = useState(false);
    const [modalData, setModalData] = useState();

    function handleClickOpen(data) {
        setOpen(true);
        setModalData(data);
        // console.log(data , 'job details');
    }
    function handleClose() {
        setOpen(false);
    }

    useEffect(() => {
        getCareer()

    }, [])

    const getCareer = () => {
        api.getCareer().then((res) => {
            // console.log("res==>>", res);
            setCareer(res.data.activeCareer)

        })
            .catch((err) => {
                // console.log(err.response);
            })
    }

    return (
        <>
            <div className='pt-1'>
                <Paper>
                    <div className='pt-5'>
                        <div className="text-center">
                            <h2> PEWS (Purbanchal Educational Welfare Society) - Career </h2>
                        </div>

                        <div className='text-center pb-4 px-4'>
                            <i> The PEWS (Purbanchal Educational Welfare Society) Group of Institutions offers diverse opportunities for individuals passionate about making a positive impact in the field of education and community development. Committed to empowering the region through education, PEWS seeks dedicated professionals to join its team.</i>
                        </div>
                    </div>
                    <FormDialog open={open} handleClickOpen={handleClickOpen} handleClose={handleClose}
                        form={<AddHiring handleClose={handleClose} modalData={modalData} />} />
                    <div className='row p-5'>
                        {career && career.map((c) => (
                            <div className="col-md-4 p-2">
                                <Paper elevation={3}>

                                    <div className='p-3'>

                                        <h5>
                                            Post: <span className='text-primary'> {c.post} </span>
                                        </h5>
                                        <h6>
                                            Minimum Qualification: <span className='text-primary'> {c.qualification} </span>
                                        </h6>
                                        {c.end_date &&
                                            <h6>
                                                Last date of submission: <span className='text-primary'>{c.end_date}</span>
                                            </h6>
                                        }
                                        {c.details &&
                                            <div className='py-3' style={{ fontSize: 'small' }}>
                                                {c.details}
                                            </div>
                                        }
                                        <div className='text-center w-100 mb-2'>
                                            <button className='btn btn-sm btn-primary' onClick={() => handleClickOpen(c)}>Apply Now</button>
                                        </div>

                                        <div style={{ fontSize: 'small' }}>
                                            Or Send your CV at <a href={`mailto:${c.official_mail}`}> {c.official_mail} </a>
                                        </div>
                                        <div className='pt-3' style={{ fontSize: 'small' }}>
                                            For more details reach us at <b> +91 8811099994 / 8453006882 </b>
                                        </div>
                                    </div>
                                </Paper>
                            </div>

                        ))}

                    </div>

                </Paper>
            </div>
        </>
    )
}

export default Hiring;